/// <reference path="../_references.ts"/>

module App.Utils {
	import Appointment = App.Appointments.Appointment;
	import AppointmentService = App.Appointments.AppointmentService;
	import AppRootScope = App.Administrative.AppRootScope;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import UserSession = App.User.UserSession;

	export class OfficeService {
		constructor(
			private $rootScope: AppRootScope,
			private $location: ng.ILocationService,
			private AppointmentService: AppointmentService,
			private SelectedAppointment: SelectedAppointment,
			private UserSession: UserSession,
			private $q: ng.IQService
		) {
			if($location.search().office) {
				$rootScope.app.hideAppHeader();
			}
		}

		getAppointment(): ng.IHttpPromise<Appointment> {
			if(this.$location.search().apptId && this.$location.search().office) {
				this.SelectedAppointment.clear();

				if (this.$location.search().officeOrg) {
					this.$rootScope.app.setOrganization(this.$location.search().officeOrg);
				}

				return this.AppointmentService.fetch(this.$location.search().apptId).then((resp) => {
					this.SelectedAppointment.set(resp.data);
					return resp;
				});
			}

			return this.$q.reject();
		}

		public static Factory() {
			let instance = (
				$rootScope: AppRootScope,
				$location: ng.ILocationService,
				AppointmentService: AppointmentService,
				SelectedAppointment: SelectedAppointment,
				UserSession: UserSession,
				$q: ng.IQService
			) => {
				return new OfficeService(
					$rootScope,
					$location,
					AppointmentService,
					SelectedAppointment,
					UserSession,
					$q
				);
			};

			return instance;
		}
	}
}
